import { render, staticRenderFns } from "./AdminAuthorityTransfer.vue?vue&type=template&id=75d9c93c&"
import script from "./AdminAuthorityTransfer.vue?vue&type=script&lang=js&"
export * from "./AdminAuthorityTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports